module.exports = __webpack_public_path__ + "img/isfp.2e24a197.png";